import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { projectRequestAPI } from '../redux/project-requests.slice';

export function useProjectRequest(id: string | null | undefined) {
  const { entity: projectRequest } = useEntityIdSelector(projectRequestAPI, id);
  return { projectRequest };
}
